module.exports = __webpack_public_path__ + "android-icon-36x36.png?7fbdd63b65412fba6ff2725e0296a252";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android-icon-36x36.png
// module id = 123
// module chunks = 0